import JSONP from 'jsonp'
import axios from 'axios'
import { Modal } from 'antd';

export default class Axios {
    static jsonp(options) {
        return new Promise((resolve, reject) => {
            JSONP(options.url, {
                param: 'callback'
            }, function (err, response) {
                if (response.status === 'success') {
                    resolve(response);
                } else {
                    reject(response.message);
                }
            })
        })
    }

    static ajax(options, method = 'post') {
        let loading;
        if (options.data && options.data.isShowLoading !== false) {
            loading = document.getElementById('ajaxLoading');
            loading.style.display = 'block';
        }
        let baseApi = 'http://139.155.14.228:90/api'
        // let baseApi ='http://localhost:52564/api'
        return new Promise((resolve, reject) => {
            axios({
                url: options.url,
                method: method,
                baseURL: baseApi,
                timeout: 10000,
                // headers: { "Access-Control-Allow-Origin": 'http://139.155.14.228:90', "Access-Control-Allow-Credentials": true },
                data: (options.data && options.data.params) ? options.data.params : ''
                // params: (options.data && options.data.params) ? options.data.params : ''
            }).then((res) => {
                if (options.data && options.data.isShowLoading !== false) {
                    loading = document.getElementById('ajaxLoading');
                    loading.style.display = 'none';
                }
                if (res.status === 200) {
                    let r = res.data;
                    if ((r.code + '') === "200") {
                        resolve(r);
                    } else {
                        Modal.info({
                            title: '提示',
                            content: r.msg
                        })
                    }
                } else {
                    loading = document.getElementById('ajaxLoading');
                    loading.style.display = 'none';
                    reject(res.data);
                }
            }).catch(e => {
                loading = document.getElementById('ajaxLoading');
                loading.style.display = 'none';
                reject({message: e.message, code: -1});
            })
        })
    }
}